import { useQuery } from '@tanstack/react-query';
import { IAccountSnapshot } from '../../../models/AdminModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { IAccountFilterCriteria } from '../../../viewmodels/AdminViewModels';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_KEY = `admin/accountsnapshot/byMonth/renewalSummary`;

export function useAdminAccountSnapshotByMonthRenewalSummaryQuery({ filter }: { filter: IAccountFilterCriteria }) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_KEY, filter],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IAccountSnapshot[]>(
				`admin/accountsnapshot/byMonth/renewalSummary`,
				'POST',
				filter
			),
	});
}

export function invalidateAdminAccountSnapshotByMonthRenewalSummaryQuery() {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_KEY] });
}
